import { get } from 'lodash';

import { HUB_CONNECTION_STATE } from '../const/paymentKiosk';

import { VERIFICATION_PENDING, AWAITING_PROCESSING } from '../const/orderStatus';
import { UNPAID } from '../const/paymentStatus';

import { getPaymentKioskConfiguration } from '../selectors/configSelectors';

export const isHubConnected = state => state.paymentKiosk.hubConnection.connectionState === HUB_CONNECTION_STATE.CONNECTED;

export const getPaymentKioskSettings = state => state.paymentKiosk.kioskSettings;
export const isIdScanInError = state => state.paymentKiosk.idScan.isInError;
export const isIdScanActive = state => state.paymentKiosk.idScan.isActive;
export const shouldHandleOrdersAfterLogin = state => state.paymentKiosk.loginForm.shouldHandleOrders;

export const getPayableOrderStatuses = (state) => {
  const paymentKioskConfiguration = getPaymentKioskConfiguration(state);

  const payableOrderStatuses = get(
    paymentKioskConfiguration,
    'ordersHistory.payableOrderStatuses',
    [VERIFICATION_PENDING, AWAITING_PROCESSING]
  );

  return payableOrderStatuses;
}

export const getPayablePaymentStatuses = (state) => {
  const paymentKioskConfiguration = getPaymentKioskConfiguration(state);

  const payablePaymentStatuses = get(
    paymentKioskConfiguration,
    'ordersHistory.payablePaymentStatuses',
    [UNPAID]
  );

  return payablePaymentStatuses;
}



// WEBPACK FOOTER //
// ./src/selectors/paymentKioskSelectors.js